import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { PlansTeaserBG } from "@/components/site/PlansTeaserBG";

import { pageSchemas } from "@/lib/seo/page-schema";
const DESC =
  "Индивидуално ценообразуване за платформата и услугите за медиен мониторинг на Perceptica - според вашите брандове, езици и пазари в ЮИЕ.";

export const Route = createFileRoute("/bg/pricing")({
  head: () => ({
    meta: [
      { title: "Ценообразуване - платформа за медиен мониторинг | Perceptica" },
      { name: "description", content: DESC },
      { property: "og:title", content: "Ценообразуване - платформа за медиен мониторинг | Perceptica" },
      { property: "og:description", content: DESC },

      ...ogImageMeta("bg", "/pricing", "Ценообразуване на Perceptica"),
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Ценообразуване - платформа за медиен мониторинг | Perceptica" },
      { name: "twitter:description", content: DESC },
      { property: "og:url", content: "https://perceptica.com/bg/pricing" },
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/pricing" }),
  }),
  component: PricingPage,
});

function PricingPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main id="main">
        <section className="border-b border-border/60 bg-secondary/40 py-20 lg:py-28">
          <div className="mx-auto max-w-[900px] px-6 text-center lg:px-10">
            <h1 className="font-display mt-4 text-[clamp(2.25rem,4vw,3.25rem)] font-medium text-foreground">
              План за всеки етап на вашия екип
            </h1>
            <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-foreground/75">
              Ценообразуването е съобразено с организациите, пазарите и езиците, които покривате. Разкажете ни за
              вашия екип, за да подготвим персонализирана оферта. На повечето запитвания отговаряме в рамките на един работен ден.
            </p>
          </div>
        </section>
        <PlansTeaserBG />
      </main>
      <SiteFooter />
    </div>
  );
}
